import { layoutModeTypes } from '../../constants/layout'

export const THEME_STORAGE_KEY = 'acig.theme'

/** Persisted choice wins; otherwise follow the OS preference. */
export const getInitialThemeMode = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY)
    if (saved === layoutModeTypes.DARK || saved === layoutModeTypes.LIGHT) return saved
  } catch { /* storage unavailable */ }
  return typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? layoutModeTypes.DARK
    : layoutModeTypes.LIGHT
}

export const persistThemeMode = (mode) => {
  try { localStorage.setItem(THEME_STORAGE_KEY, mode) } catch { /* ignore */ }
}
